export enum AttachmentStatus {
  Done = 'done',
  Failed = 'failed',
  Uploading = 'uploading',
}
